<template>
  <div :class="['calendar', { calendar__inline: inline }]">
    <div class="calendar__title">
      {{ $tr('onlineInterview.room.addCalendar') }}
    </div>
    <div class="calendar__calend">
      <a
        class="calendar__client"
        :href="google_event"
        target="_blank"
        rel="noopener"
      >
        <img src="/static/images/elements/google.svg" alt="calendar" />
        <span>Google</span>
      </a>
      <a
        class="calendar__client"
        :href="outlook_event"
        target="_blank"
        rel="noopener"
      >
        <img src="/static/images/elements/outlook.svg" alt="calendar" />
        <span>Outlook</span>
      </a>
      <!--       <a class="calendar__client" href="https://calendar.google.com/calendar/r" target="_blank" rel="noopener">
        <img src="/static/images/elements/iCal.svg" alt="calendar">
        <span>iCal</span>
      </a> -->
    </div>
  </div>
</template>

<script>
  import Moment from 'moment';

  export default {
    name: 'add-calendar',

    props: {
      inline: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: ''
      },
      link: {
        type: String,
        default: ''
      },
      date: {
        type: String,
        default: ''
      }
    },

    data() {
      return {};
    },

    computed: {
      google_event() {
        return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${this.name}&dates=${this.app_date}&details=${this.link}`;
      },

      outlook_event() {
        return `https://outlook.live.com/owa/?path=/calendar/action/compose&subject=${this.name}&startdt=${this.outlook_format_date}&enddt=${this.outlook_format_date}&body=${this.link}`;
      },

      current_date() {
        return this.$store.getters['online_interview/current_date'];
      },

      google_format_date() {
        return Moment(this.date, 'YYYY-MM-DD hh:mm:ss').format(
          'YYYYMMDDTHHmmss'
        );
      },

      outlook_format_date() {
        return Moment(this.date, 'YYYY-MM-DD hh:mm:ss').format(
          'YYYY-MM-DDTHH:mm:ss'
        );
      },

      app_date() {
        if (!this.date) {
          const current_date = Moment(this.current_date, 'DD-MM-YYYY').format(
            'YYYYMMDD'
          );
          return `${this.current_date}/${this.current_date}`;
        }
        return `${this.google_format_date}/${this.google_format_date}`;
      }
    },

    methods: {}
  };
</script>

<style lang="scss" scoped>
  .calendar {
    margin-left: 3px;
    margin-bottom: -3px;

    &__inline {
      display: flex;
      align-items: center;

      .calendar__calend {
        margin-left: 31px;
      }
    }

    &__title {
      font-weight: 300;
      font-size: 15px;
      line-height: 22px;
      letter-spacing: 0.005em;
      color: #233346;
      margin-bottom: 12px;
    }

    &__calend {
      display: flex;
      margin-bottom: 9px;
      margin-left: -1px;
    }

    &__client {
      display: flex;
      align-items: center;
      margin-right: 38px;
      color: #233346;

      &:hover {
        color: #233346;
      }

      img {
        display: inline-block;
        margin-right: 9px;
      }
    }
  }
</style>
